import { render } from "./YoutubePlayer.vue?vue&type=template&id=1e98ff8b"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"
script.render = render

export default script